/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleStatementManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleStatementManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_USERS (state, users) {
      state.users = users;
    },
    SET_STATEMENT_USER (state, statementUser) {
      state.statementUser = statementUser;
    },
    SET_STATEMENT (state, statement) {
      state.statement = statement;
    },
    SET_POPUP (state, popup) {
      state.popup = popup;
    },
    SET_POPUP2 (state, popup) {
      state.popup2 = popup;
    },
    SET_POPUP3 (state, popup) {
      state.popup3 = popup;
    },
    SET_SELECTED (state, selected) {
      state.selected = selected;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
}

